import type { SupportedChainName } from "../types/base"

/**
 * Maps a `defuseAssetId` to the 1CS routing asset id used as the destination
 * asset in withdraw quotes, when the two differ.
 *
 * Example: `nep141:nbtc.bridge.near` is held on Intents as a NEP-141, but 1CS
 * routes BTC via the native `1cs_v1:btc:native:coin` asset on the Bitcoin chain.
 */
export const NBTC_DEFUSE_ASSET_ID = "nep141:nbtc.bridge.near"

export const ONE_CLICK_BTC_NATIVE_ASSET_ID = "1cs_v1:btc:native:coin"

const ONE_CLICK_BTC_ROUTING_OVERRIDES: Record<string, string> = {
  [NBTC_DEFUSE_ASSET_ID]: ONE_CLICK_BTC_NATIVE_ASSET_ID,
}

const DEFUSE_BY_ONE_CLICK_ROUTING_ASSET: Record<string, string> =
  Object.fromEntries(
    Object.entries(ONE_CLICK_BTC_ROUTING_OVERRIDES).map(
      ([defuse, oneClick]) => [oneClick, defuse]
    )
  )

export function getWithdrawDestinationAsset(defuseAssetId: string): string {
  return ONE_CLICK_BTC_ROUTING_OVERRIDES[defuseAssetId] ?? defuseAssetId
}

/** Map 1CS routing asset ids from history/quote APIs back to token-list defuse ids. */
export function resolveDefuseAssetIdFromHistory(assetId: string): string {
  return DEFUSE_BY_ONE_CLICK_ROUTING_ASSET[assetId] ?? assetId
}

/**
 * Maps Intents-held nBTC to the 1CS native BTC asset for ORIGIN_CHAIN deposits
 * when the user selected the Bitcoin network. Without this, 1CS treats
 * `nep141:nbtc.bridge.near` as a NEAR-chain deposit and returns a 64-char implicit account.
 */
export function getDepositOriginAsset(
  defuseAssetId: string,
  originChainName: SupportedChainName
): string {
  if (originChainName === "bitcoin") {
    return getWithdrawDestinationAsset(defuseAssetId)
  }
  return defuseAssetId
}
